import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import Highcharts from 'highcharts';
import HC_stock from 'highcharts/modules/stock';
import HC_more from 'highcharts/highcharts-more';

import { AppModule } from './app/app.module';
import { environment } from '@firebird-web/shared-config';
import { allowHighchartsSvgIcons } from 'libs/charts/src/lib/utils/highcharts-ast.utils';

// Required: load, renewable and forecast-values rely on this global Stock/More registration.
HC_stock(Highcharts);
HC_more(Highcharts);
// Before any chart renders, so useHTML tooltips keep their inline <svg> legend icons.
allowHighchartsSvgIcons();

let enableSentry = true;
if (environment.production) {
  enableProdMode();
}

if (
  environment.sentryEnv === 'local' ||
  environment.sentryEnv.startsWith('pre-dev')
) {
  enableSentry = false;
}

Sentry.init({
  dsn: 'https://919559628056e29baece83de57847090@o4507181837189120.ingest.us.sentry.io/4507505452187648',
  environment: environment.sentryEnv,
  enabled: enableSentry,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.01, // 1% of transactions will be sent to Sentry
  tracePropagationTargets: ['localhost', environment.apiDomain],
});

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error(err);
  });
